import React, {useState, useEffect, useCallback} from 'react'
import Select, {components} from 'react-select'
import {Box, Flex, Image, Text, useMultiStyleConfig} from '@chakra-ui/react'
import countries from '../../../utils/country-data'
import PropTypes from 'prop-types'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCheckout} from '../../../pages/checkout/util/checkout-context'
const PhoneDialCode = ({onChange, value}) => {
    const {locale} = useMultiSite()
    const styles = useMultiStyleConfig('PhoneDialCode')
    const {setDialCountry} = useCheckout()
    const countryCodeId = locale?.id.split('-')[1] || 'CH'

    const initialCountry =
        countries.find((country) => country.code === countryCodeId) || countries[0]

    const options = countries.map((c, index) => ({
        _index: index,
        value: c.code,
        label: `${c.dial_code}`,
        name: c.name,
        dial_code: c.dial_code,
        validation: c.validation,
        flag: c.flag
    }))

    const [selectedCountry, setSelectedCountry] = useState(
        () =>
            options.find((opt) => opt.dial_code === value) ||
            options.find((opt) => opt.value === initialCountry.code)
    )

    useEffect(() => {
        const matched = options.find((opt) => opt.dial_code === value)
        if (matched) {
            setSelectedCountry(matched)
        }
    }, [value])

    useEffect(() => {
        if (value === '' && selectedCountry?.dial_code) {
            onChange?.(selectedCountry.dial_code)
        }
    }, [value, selectedCountry, onChange])

    const handleCountryChange = useCallback(
        (selected) => {
            setSelectedCountry(selected)
            setDialCountry?.(selected.value)
            onChange?.(selected.dial_code)
        },

        [onChange, setDialCountry]
    )

    const DropdownIndicator = (props) => {
        const {menuIsOpen} = props.selectProps
        return (
            <components.DropdownIndicator {...props}>
                <Box
                    {...styles.countryDropDownArrow}
                    as="span"
                    transform={menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                />
            </components.DropdownIndicator>
        )
    }

    const formatOptionLabel = ({name, label, flag, _index}) => (
        <>
            <Flex {...styles.menuOptions}>
                <Image src={flag} alt="flag" {...styles.menuOptionsIcon} />
                <Box {...styles.menuOptionsValueText}>
                    {name}{' '}
                    <Text as="span" {...styles.menuOptionsValueText.light}>
                        {label}
                    </Text>
                </Box>
            </Flex>
            {_index === 1 && <Box as="hr" {...styles.menuDivider} />}
        </>
    )

    const CustomSingleValue = (props) => {
        const {data} = props
        return (
            <components.SingleValue {...props}>
                <Flex {...styles.dropDown}>
                    <Image src={data.flag} alt={data.name} {...styles.icon} />
                </Flex>
            </components.SingleValue>
        )
    }

    DropdownIndicator.propTypes = {
        selectProps: PropTypes.shape({
            menuIsOpen: PropTypes.bool.isRequired
        }).isRequired
    }

    CustomSingleValue.propTypes = {
        data: PropTypes.shape({
            flag: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired
        }).isRequired
    }

    return (
        <Box>
            <Select
                options={options}
                value={selectedCountry}
                onChange={handleCountryChange}
                styles={styles.countrySelect}
                formatOptionLabel={formatOptionLabel}
                menuPortalTarget={document.body}
                isSearchable={false}
                components={{
                    SingleValue: CustomSingleValue,
                    DropdownIndicator: DropdownIndicator
                }}
            />
        </Box>
    )
}

PhoneDialCode.propTypes = {
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.any})]),
    value: PropTypes.string,
    onChange: PropTypes.func
}

export default PhoneDialCode
